module.exports = __webpack_public_path__ + "static/media/1005251.da2a2acd.jpg";